import React from "react"
import { Link } from "gatsby"
import { Card, Icon, Image } from "semantic-ui-react"
import styled from "styled-components"
import { numberWithCommas } from "../utilities/utilities"

const cardContainer = {
  marginTop: "25px",
}

const cardImage = {
  // height: '200px',
  objectFit: "cover",
  imageOrientation: "from-image",
}

const CustomCard = styled(Card)`
  &&& {
    &:hover {
      box-shadow: rgb(187, 187, 187) 0px 2px 8px;
    }
  }
`

const CardExampleCard = props => (
  <div style={cardContainer}>
    <Link to={`/products/${props.info.slug}`}>
      <CustomCard centered>
        <Image src={props.info.images[0].url} style={cardImage} />
        <Card.Content>
          <Card.Header>{props.info.product}</Card.Header>
          <Card.Description>
            {props.info.description.slice(0, 100)}
            {props.info.description.length > 100 && <span> ...</span>}
          </Card.Description>
        </Card.Content>
        <Card.Content extra>
          {props.info.price === 0 && (
            <span style={{ color: "#00B5AD", fontSize: "1.2em" }}>FREE</span>
          )}
          {props.info.price !== 0 && (
            <span style={{ color: "#00B5AD", fontSize: "1.2em" }}>
              <Icon name="yen" color="teal" />
              {numberWithCommas(props.info.price)}
            </span>
          )}
        </Card.Content>
      </CustomCard>
    </Link>
  </div>
)

export default CardExampleCard
